import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const AboutSection = () => {
  const { language } = useLanguage();
  
  const aboutContent = {
    tr: {
      title: 'Hakkımızda',
      description: 'Movent Logistics, Türkiye genelinde lojistik, nakliye ve taşımacılık hizmetleri sunan köklü bir firmadır. Modern araç filosu, deneyimli personeli ve gelişmiş takip sistemleriyle hızlı, güvenli ve uygun maliyetli çözümler üretmektedir. Zamanında teslimat, profesyonel hizmet ve müşteri memnuniyeti bizim önceliğimizdir.',
      readMore: 'Detaylı Bilgi',
      stats: [
        { value: '15+', label: 'Yıllık Tecrübe' },
        { value: '10,000+', label: 'Başarılı Teslimat' },
        { value: '500+', label: 'Mutlu Müşteri' }
      ]
    },
    en: {
      title: 'About Us',
      description: 'Movent Logistics is a well-established company providing logistics, freight and transportation services throughout Turkey. With our modern fleet, experienced staff and advanced tracking systems, we produce fast, safe and cost-effective solutions. On-time delivery, professional service and customer satisfaction are our priorities.',
      readMore: 'Learn More',
      stats: [
        { value: '15+', label: 'Years Experience' },
        { value: '10,000+', label: 'Successful Deliveries' },
        { value: '500+', label: 'Happy Clients' }
      ]
    }
  };

  const content = aboutContent[language];
  
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1644079446600-219068676743?w=800&q=80"
              alt="About Movent Logistics"
              className="rounded-lg shadow-xl w-full"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#DF6A6A] text-white p-8 rounded-lg shadow-xl hidden lg:block">
              <TrendingUp className="w-12 h-12" />
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-6">
              {content.title}
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {content.description}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              {content.stats.map((stat, index) => (
                <div key={index} className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="text-3xl font-bold text-[#DF6A6A] mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              className="inline-flex items-center px-8 py-3 bg-[#36344D] text-white rounded-md hover:bg-[#2a2839] transition-colors duration-300 font-semibold"
            >
              {content.readMore}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;